import * as Yup from "yup";

const nfEntradaItemXmlObjectValidator = Yup.object().shape({
  tipo: Yup.string().required(),
  codigoBarra: Yup.string().nullable(),
  descricao: Yup.string().required("Descrição"),
  produto: Yup.string().required("Descrição"),
  unidadeComercialCompraId: Yup.mixed().test(
    "is-number",
    "Unidade comercial de compra",
    (value) => value && !isNaN(Number(value))
  ),
  unidadeComercialVendaId: Yup.mixed().test(
    "is-number",
    "Unidade comercial de venda",
    (value) => value && !isNaN(Number(value))
  ),
  conversorEntrada: Yup.number().nullable(),
  fracionavel: Yup.string().nullable(),
  precoCompra: Yup.number().nullable(),
  usoConsumo: Yup.boolean().nullable(),
  grupoProdutoId: Yup.number()
    .nullable()
    .when("usoConsumo", {
      is: true,
      then: Yup.number().nullable(),
      otherwise: Yup.number().required("Grupo de Produto"),
    }),
  grupoTributacaoId: Yup.number()
    .nullable()
    .when("usoConsumo", {
      is: true,
      then: Yup.number().nullable(),
      otherwise: Yup.number().required("Grupo tributário"),
    }),
  generoItemId: Yup.number().nullable(),
  tipoItemId: Yup.number().nullable(),
  origemMercadoriaId: Yup.number().required("Origem Mercadoria Id"),
  tributosIcmsOrigem: Yup.number().required("Tributos ICMS Origem"),
  ncmId: Yup.number().required("NCM ID"),
  ncmCodigo: Yup.string()
    .min(8, "NCM deve ter pelo menos 8 caracteres")
    .required("NCM Código"),
  ncm: Yup.string()
    .min(8, "NCM deve ter pelo menos 8 caracteres")
    .required("NCM Código"),
  cestId: Yup.number().nullable(),
  cfopId: Yup.number().nullable().required("CFOP"),
  cfop: Yup.string()
    .min(4, "CFOP deve ter pelo menos 4 caracteres")
    .nullable()
    .required("CFOP"),
  informacaoAdicionalNfe: Yup.string().nullable(),
});

const nfEntradaItensXmlValidator = Yup.array()
  .of(nfEntradaItemXmlObjectValidator)
  .optional();

export const nfEntradaItensXmlExcetoUsoConsumoValidator = Yup.array().of(
  Yup.lazy((item) =>
    item?.usoConsumo ? Yup.object() : nfEntradaItemXmlObjectValidator
  )
);

export default nfEntradaItensXmlValidator;
